var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11493_2692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 35.0005L2.9845 26.1302C-7.51642 8.10414 17.1229 -9.68708 30.7486 6.10125C43.2453 20.5819 25.8028 41.1105 9.38116 32.0629L0 35.0005ZM4.48364 30.7668C5.59421 30.5619 8.93739 29.001 9.79733 29.0862C10.8596 29.1921 13.3038 30.9463 15.3823 31.195C34.3907 33.4672 37.7753 7.54241 21.6066 3.54353C8.18092 0.223793 -1.45776 14.3177 6.12534 25.6559L4.48134 30.7668H4.48364Z",
    fill: "url(#paint0_linear_11493_2692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.391 9.39841C13.5842 9.50891 15.1615 13.1901 15.1822 13.4733C15.265 14.6543 13.6279 15.3035 13.8026 16.0908C15.1615 18.5288 17.1918 20.3361 19.8383 21.2592L22.0801 19.086C24.3012 19.6661 28.3411 21.128 25.6233 23.8952C23.1723 26.3908 18.999 24.6641 16.4514 23.147C13.0484 21.1211 6.41955 13.715 10.7238 9.98316C11.2619 9.51582 12.7817 9.04387 13.3933 9.39611L13.391 9.39841Z",
    fill: "url(#paint1_linear_11493_2692)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11493_2692",
    x1: 17.5005,
    y1: 0,
    x2: 17.5005,
    y2: 35.0005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08873B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11493_2692",
    x1: 18,
    y1: 4.9977e-7,
    x2: 18.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47BE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07863A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11493_2692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.6b678d09c137f2f48fd7a4d4e4255825.svg";
export { ForwardRef as ReactComponent };